import React from 'react';
import { Link } from 'react-router-dom';
import { FaTwitter, FaSteam, FaYoutube, FaEnvelope } from 'react-icons/fa';
import wordmark from './images/voidmaw-wordmark.png';
import './SiteFooter.css';

// The landing page has no top bar, so studio-level links live down here.
// `steamHref` is per-game, the same way the header handles it.
// `showMark` is off on the landing page, where the wordmark is already the
// hero and repeating it a few hundred pixels below just reads as a duplicate.
function SiteFooter({ showContact = true, showMark = true, steamHref }) {
  return (
    <footer className="site-footer">
      {showMark && <img src={wordmark} alt="Voidmaw" className="site-footer-mark" />}
      <div className="site-footer-links">
        {showContact && (
          <Link to="/contact" className="site-footer-link">Contact</Link>
        )}
        <span className="site-footer-icons">
          <a href="mailto:contact@voidmaw.com" className="site-footer-icon" aria-label="Email Voidmaw">
            <FaEnvelope size={17} />
          </a>
          {steamHref && (
            <a href={steamHref} target="_blank" rel="noopener noreferrer" className="site-footer-icon" aria-label="View on Steam">
              <FaSteam size={17} />
            </a>
          )}
          <a href="https://x.com/VoidmawGames" target="_blank" rel="noopener noreferrer" className="site-footer-icon" aria-label="Voidmaw on X">
            <FaTwitter size={17} />
          </a>
          <a href="https://www.youtube.com/@VoidmawGames/videos" target="_blank" rel="noopener noreferrer" className="site-footer-icon" aria-label="Voidmaw on YouTube">
            <FaYoutube size={17} />
          </a>
        </span>
      </div>
    </footer>
  );
}

export default SiteFooter;
